import { render, staticRenderFns } from "./SMSChat.vue?vue&type=template&id=02e9d51e&scoped=true&"
import script from "./SMSChat.vue?vue&type=script&lang=js&"
export * from "./SMSChat.vue?vue&type=script&lang=js&"
import style0 from "./SMSChat.vue?vue&type=style&index=0&id=02e9d51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e9d51e",
  null
  
)

export default component.exports